import { uiRows } from './types-def.js';
/**
 * `web/bootstrap` (2.J; CS r5b deliverable 165): the bootstrap wizard, three steps (past sessions,
 * NOW and the status map, the ledger's marks), each previewed, applied as one batch and undoable.
 * Every action has a visible control (DECISIONS 161).
 */
export const BOOTSTRAP_INTERACTIONS = uiRows([
    {
        id: 'bootstrap.step.preview',
        module: 'web/bootstrap',
        behavior: "Each step's Preview lists what applying it would write, and writes nothing",
        owner: '2.J',
        since: 'exit-2b',
    },
    {
        id: 'bootstrap.step.apply',
        module: 'web/bootstrap',
        behavior: "Each step's Apply writes its previewed rows as one batch and moves to the next step",
        owner: '2.J',
        since: 'exit-2b',
    },
    {
        id: 'bootstrap.step.undo',
        module: 'web/bootstrap',
        behavior: "An applied step's Undo button reverts that step's batch",
        owner: '2.J',
        since: 'exit-2b',
    },
    {
        id: 'bootstrap.ledger.select',
        module: 'web/bootstrap',
        behavior: 'The ledger step selects its targets by checkbox, a filter and "Select all shown"',
        owner: '2.J',
        since: 'exit-2b',
    },
    {
        id: 'bootstrap.sessions.count',
        module: 'web/bootstrap',
        behavior: 'The sessions step takes how many sessions were played, by its number field',
        owner: '2.J',
        since: 'exit-2b',
    },
    {
        id: 'bootstrap.now.set',
        module: 'web/bootstrap',
        behavior: 'The NOW field sets the campaign clock to the point typed',
        owner: '2.J',
        since: 'exit-2b',
    },
    {
        id: 'bootstrap.status.map',
        module: 'web/bootstrap',
        behavior: "The status map's table maps each option of a select field to a status and a play state",
        owner: '2.J',
        since: 'exit-2b',
    },
]);
//# sourceMappingURL=bootstrap.js.map